<template>
  <h2 class="notice-board-head">SCHOOL NEWS BULLETIN BOARD</h2>
  <div
    v-for="announcement in announcements"
    :key="announcement.id"
    class="notice-board-snippet"
  >
    <single-bulletin :announcement="announcement" />
  </div>
</template>

<script>
import SingleBulletin from './SingleBulletin.vue'
export default {
  components: { SingleBulletin },
  props: ['announcements']
}
</script>

<style>
.notice-board-head {
  color: whitesmoke;
  background: #333;
  padding: 30px;
  margin: 0 auto;
}
.notice-board-snippet {
  color: whitesmoke;
  background: #333;
  padding: 20px;
  margin: 0 auto;
}
</style>
